export default function SpinnerSan({
  progress,
  size,
}: {
  progress?: boolean;
  size: number;
}) {
  return (
    <div
      role="progressbar"
      aria-label="Loading…"
      className="relative text-gray-text"
      style={{ width: size, height: size }}
    >
      <svg
        viewBox="0 0 180 180"
        xmlns="http://www.w3.org/2000/svg"
        className="absolute inset-0 h-full w-full"
      >
        {progress === true ?
          <>
            <g fill="currentColor">
              <path d="m87.6 96.481c1.4191 0.8759 3.0866 1.6423 5.0024 2.2992 1.9867 0.5839 4.009 0.8759 6.0667 0.8759 2.3414 0 4.3284-0.5839 5.9604-1.7518 1.632-1.2408 2.448-3.2116 2.448-5.9122 0-2.2627-0.497-4.124-1.49-5.5838-0.994-1.4598-2.271-2.7736-3.832-3.9415-1.49-1.1678-3.1219-2.2262-4.8958-3.1751-1.7739-1.0218-3.4413-2.2262-5.0024-3.613-1.49-1.3868-2.7317-3.0291-3.7251-4.9268-0.9934-1.8978-1.4901-4.3065-1.4901-7.2261 0-4.6714 1.2063-8.1749 3.6187-10.511 2.4835-2.4087 5.9603-3.6131 10.431-3.6131 2.909 0 5.428 0.292 7.557 0.8759 2.128 0.511 3.973 1.2409 5.534 2.1897l-2.022 6.5692c-1.348-0.7299-2.909-1.3138-4.683-1.7518-1.774-0.5109-3.583-0.7664-5.428-0.7664-2.5547 0-4.435 0.5474-5.6412 1.6423-1.1353 1.0949-1.703 2.8101-1.703 5.1458 0 1.8248 0.4967 3.3941 1.4901 4.7079 0.9934 1.2409 2.2351 2.4087 3.7252 3.5036 1.5609 1.0218 3.2289 2.0802 5.0019 3.175 1.774 1.0949 3.406 2.4087 4.896 3.9415 1.561 1.4598 2.839 3.2481 3.832 5.3648 0.993 2.0438 1.49 4.6349 1.49 7.7735 0 2.0438-0.319 3.978-0.958 5.8028-0.638 1.8247-1.632 3.4309-2.98 4.8169-1.277 1.314-2.909 2.373-4.896 3.176-1.916 0.802-4.186 1.204-6.8117 1.204-3.122 0-5.8183-0.329-8.0889-0.986-2.2706-0.583-4.1864-1.386-5.7474-2.408l2.3415-6.8978z" />
              <circle cx="65" cy="77" r="6" />
              <circle cx="134.29" cy="76.916" r="6" />
            </g>
            <rect
              x="20"
              y="142"
              width="160"
              height="5"
              rx="2.5"
              className="fill-background-main"
            />
            <rect
              x="20"
              y="142"
              width="5"
              height="5"
              rx="2.5"
              fill="currentColor"
            >
              <animate
                attributeName="width"
                begin="0s"
                dur="1.2s"
                from="0"
                repeatCount="indefinite"
                to="155"
              />
            </rect>
          </>
        : <g fill="currentColor">
            <path d="m74.102 113.08c1.8195 1.099 3.9574 2.061 6.4137 2.885 2.5473 0.733 5.1401 1.1 7.7783 1.1 3.0022 0 5.5495-0.733 7.6419-2.199 2.0924-1.557 3.1386-4.03 3.1386-7.42 0-2.839-0.6368-5.175-1.9104-7.007-1.2737-1.8323-2.9112-3.4812-4.9127-4.9468-1.9104-1.4657-4.0029-2.7939-6.2772-3.9848-2.2744-1.2824-4.4123-2.7938-6.4138-4.5343-1.9104-1.7405-3.5025-3.8015-4.7761-6.1832-1.2737-2.3817-1.9105-5.4046-1.9105-9.0687 0-5.8626 1.5466-10.26 4.6397-13.191 3.1841-3.0228 7.6419-4.5343 13.373-4.5343 3.73 0 6.9596 0.3664 9.6889 1.0992 2.729 0.6413 5.094 1.5573 7.096 2.7481l-2.593 8.2443c-1.728-0.916-3.73-1.6489-6.0042-2.1985-2.2743-0.6412-4.5942-0.9618-6.9595-0.9618-3.2751 0-5.686 0.687-7.2325 2.0611-1.4556 1.374-2.1834 3.5267-2.1834 6.458 0 2.2901 0.6368 4.2595 1.9104 5.9084 1.2737 1.5572 2.8657 3.0229 4.7762 4.3969 2.0015 1.2825 4.1394 2.6107 6.4137 3.9848 2.2744 1.374 4.3673 3.0229 6.2773 4.9465 2.001 1.8321 3.639 4.0764 4.913 6.7328 1.273 2.5649 1.91 5.8172 1.91 9.7562 0 2.564-0.409 4.992-1.228 7.282s-2.092 4.305-3.821 6.046c-1.638 1.649-3.73 2.977-6.2773 3.985-2.4563 1.007-5.3675 1.511-8.7335 1.511-4.0029 0-7.46-0.412-10.371-1.237-2.9112-0.732-5.3676-1.74-7.369-3.023l3.0022-8.656z" />
            <ellipse cx="45.45" cy="89.1" rx="7.65" ry="8.1" />
            <circle cx="133.2" cy="89.1" r="8.1" />
          </g>
        }
      </svg>
      {progress !== true && (
        <svg
          viewBox="0 0 180 180"
          xmlns="http://www.w3.org/2000/svg"
          className="absolute inset-0 h-full w-full"
          style={{ animation: 'spinner-rotate 1.2s linear infinite' }}
        >
          <defs>
            <linearGradient
              id="spinner-san-gradient"
              x1="180"
              x2="90"
              y1="90"
              y2="180"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="currentColor" stopOpacity="0" offset="0" />
              <stop stopColor="currentColor" offset="1" />
            </linearGradient>
          </defs>
          <path
            d="m180 90c0 11.819-2.328 23.522-6.851 34.442-4.523 10.919-11.152 20.84-19.509 29.198-8.358 8.357-18.279 14.986-29.198 19.509-10.92 4.523-22.623 6.851-34.442 6.851v-5.497c11.097 0 22.085-2.186 32.338-6.433 10.252-4.246 19.568-10.471 27.415-18.317 7.846-7.847 14.071-17.163 18.317-27.415 4.247-10.253 6.433-21.241 6.433-32.338h5.497z"
            fill="url(#spinner-san-gradient)"
          />
        </svg>
      )}
    </div>
  );
}
